import { Option } from '../types/option'

export const languageOptions: Option[] = [
  { value: 'esp', label: 'Español' },
  { value: 'eng', label: 'English' },
]
